exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".jumbotron {\n  background: #16bffd; /* fallback for old browsers */ /* Chrome 10-25, Safari 5.1-6 */\n  background-image: -webkit-gradient(linear, left bottom, left top, from(#16bffdcf), to(#cb3066d6)), url(\"/assets/diamonds.jpeg\");\n  background-image: linear-gradient(to top, #16bffdcf, #cb3066d6), url(\"/assets/diamonds.jpeg\");\n  -webkit-box-shadow: 0 7px 14px rgba(50,50,93,.1), 0 3px 6px rgba(0,0,0,.08);\n          box-shadow: 0 7px 14px rgba(50,50,93,.1), 0 3px 6px rgba(0,0,0,.08);\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/homepage/homepage.component.css
// module id = ../../../../../src/app/homepage/homepage.component.css
// module chunks = main